import Order from './Order';
import ModelMarshaller from './ModelMarshaller';
import OrderItem from './OrderItem';
import OrderItemMarshaller from './OrderItemMarshaller';

export default class OrderMashaller extends ModelMarshaller<Order> {




    toJSON() {
        if (this.data instanceof Order) {

            let orders:Array<any> = [];
            this.data.$orderItems.forEach(orderItem => {
                orders.push(new OrderItemMarshaller(orderItem).toJSON)
            });

            return {
                day: {
                    date: this.data.$day.toDateString,
                    timezone_type: 3,
                    timezone: "Europe/Berlin"
                },
                orders: orders,
                order_confirmed:this.data.$orderConfirmed

            }
        }
    }
    
    toModel(): Order {
        if (this.data instanceof Order) {
            return this.data
        }
        
        let orderItems :Array<OrderItem> = []

        this.data.orders.forEach( (order:any) => {
            orderItems.push(new OrderItemMarshaller(order).toModel());
        });
        
        return new Order(new Date(this.data.day.date),Boolean(this.data.order_confirmed),orderItems)

    }


}